import { useSelector } from 'react-redux';
import { selectAllPermissions } from 'redux/user/user.selectors';
import { isAuthorized } from 'util/authorization';

export const useAuthorizationGate = (any, all, permission) => {
  const allPermissions = useSelector(selectAllPermissions);
  return isAuthorized({ permission, all, any }, allPermissions);
};
